import { X } from "lucide-react";
import { Modal } from "components/modal";
import { ContactForm } from "./contactForm";

interface ContactModalProps {
  show: boolean;
  close: () => void;
}

const ContactModal: React.FC<ContactModalProps> = ({ show, close }) => {
  return (
    <Modal show={show} close={close} contentClassName="!max-w-[560px] !p-0">
      <div className="relative p-6 sm:p-8">
        <button
          type="button"
          onClick={close}
          aria-label="Close"
          className="absolute top-5 right-5 w-9 h-9 rounded-full flex items-center justify-center text-[#475467] hover:bg-[#F2F4F7] transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <ContactForm onSuccess={close} />
      </div>
    </Modal>
  );
};

export { ContactModal };
